import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';

import {EMPTY, Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ErrorpageService} from '../services/errorpage.service';
import {ConfigService} from '../config/service/config.service';
import {MatSnackBar} from '@angular/material/snack-bar';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class BelegeInterceptor implements HttpInterceptor {
  constructor(
    private errorpageService: ErrorpageService,
    private configService: ConfigService,
    private snackbar: MatSnackBar,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(error => {
        if (error.status && !this.ignoreUrl(req.url)) {
          switch (error.status) {
            case 401:
              this.snackbar.open(
                'Deine Anmeldung ist abgelaufen. Um weiterarbeiten zu können, lade bitte die Seite neu.',
                undefined,
                {panelClass: 'error'},
              );
              return EMPTY;
            case 502:
            case 503:
              this.errorpageService.serviceUnavailable();
              return EMPTY;
          }
        }
        return throwError(() => error);
      }),
    );
  }

  private ignoreUrl(url: string): boolean {
    let ignoredUrls: string[] = [];

    if (this.configService.config) {
      ignoredUrls = [this.configService.config.beleg.naseBaseUrl];
    }

    return ignoredUrls.some(entry => url.includes(entry));
  }
}
